// export const BaseURL = 'https://api-uat.betterplace.co.in' // Uat base url
// export const ORGID = '45452840-f45c-46ad-b884-31cac26bd33a' // Uat OrgId
export const BaseURL = 'https://api.betterplace.co.in' // Prod base url
export const ORGID = '1f811279-ccae-428e-94c2-5a2172fc3d1f' // Prod OrgId

export const playStoreLink = 'https://play.google.com/store/apps/details?id=com.skilling.reliance&hl=en-IN';
export const appStoreLink = 'https://apps.apple.com/in/app/retail-samarth/id6474019973';